
export const updateLanguageByParam = ({i18n, langCode}) => {
  if (langCode) {
    i18n.changeLanguage(langCode);
  } else {
    // let the language detector do his job
    i18n.changeLanguage();
  }
}